import { TransactionProjectProvider } from '../TransactionProjectProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class TransactionProjectProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/transaction`, headers);
  }

  public createTransactionProjectProvider(token: string): TransactionProjectProvider {
    return new TransactionProjectProvider(this.apiClientFactory.createAuthorizedClient(token));
  }
}
